import * as React from 'react';
import { observer } from 'mobx-react';
import { ImportedParticipantsResource, ViewReportAction } from '../../Store/Types';
import BodyContent from './BodyContent';

interface Props {
  importedParticipantsResource: ImportedParticipantsResource;
  viewReport: ViewReportAction;
}

const Body: React.FC<Props> = ({ importedParticipantsResource, viewReport }) => (
  <tbody className="divide-y divide-gray-200 bg-white">
    <BodyContent
      importedParticipantsResource={importedParticipantsResource}
      viewReport={viewReport}
    />
  </tbody>
);

export default observer(Body);
